import {
  AfterViewInit,
  Component,
  ElementRef,
  forwardRef,
  Inject,
  NgZone,
  PLATFORM_ID,
  TransferState,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import {
  DxSelectBoxComponent,
  DxTemplateHost,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';
import { AbcTooltipDirective } from '../abc-tooltip.directive';
import { AbcCoreComponentService } from '../abcCoreComponent.service';

@Component({
  standalone: true,
  selector: 'abc-select-box',
  template: '',
  hostDirectives: [
    {
      directive: AbcTooltipDirective,
    },
  ],
  providers: [
    DxTemplateHost,
    WatcherHelper,
    IterableDifferHelper,
    NestedOptionHost,
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => _AbcSelectBoxComponent),
    },
  ],
})
export class _AbcSelectBoxComponent
  extends DxSelectBoxComponent
  implements AfterViewInit
{
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    _idh: IterableDifferHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any,
    private abcTooltipDirective: AbcTooltipDirective,
    private abcCoreComponentService: AbcCoreComponentService,
  ) {
    super(
      elementRef,
      ngZone,
      templateHost,
      _watcherHelp,
      _idh,
      optionHost,
      transferState,
      platformId,
    );
    this.stylingMode = this.stylingMode
      ? this.stylingMode
      : this.abcCoreComponentService.stylingMode;
    this.labelMode = this.labelMode ?? this.abcCoreComponentService.labelMode;
    this.abcTooltipDirective.elementClassName = '.dx-texteditor-input';
  }

  override ngAfterViewInit(): void {
    super.ngAfterViewInit();

    this.instance.endUpdate();
    this.labelMode = this.labelMode ?? this.abcCoreComponentService.labelMode;
  }
}
